import { render, staticRenderFns } from "./contentCourseActive.vue?vue&type=template&id=3676f710&"
import script from "./contentCourseActive.vue?vue&type=script&lang=js&"
export * from "./contentCourseActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports